import { useEffect } from 'react';
import classNames from 'classnames/bind';
import { shallow } from 'zustand/shallow';

import DiscoverTabs from '../../../../shared/discover-tabs-enum';
import useDiscoverStore, { DiscoverActions } from '../../../../zustand-stores/DiscoverStore';
import { startCase } from '../../../../shared/string-manipulations';
import { useUrlParams } from '../../../../hooks';

import styles from '../../../../styles/main.module.scss';

const { updateSubView } = DiscoverActions;

const cx = classNames.bind(styles);

const SubTabBar = () => {
  const { view, subView } = useDiscoverStore(
    store => ({
      view: store.view,
      subView: store.subView,
    }),
    shallow
  );

  const { urlParams, updateUrlParams } = useUrlParams();

  const { subView: urlSubView } = urlParams;

  useEffect(() => {
    if (!urlSubView) updateUrlParams({ subView });
  }, [updateUrlParams, urlSubView, subView]);

  const { subTabs = [] } = DiscoverTabs[view] || {};

  const selectSubView = tabValue => {
    updateUrlParams({
      subView: tabValue,
      // Remove any view-specific filters
      programTypes: undefined,
    });
    updateSubView(tabValue);
  };

  if (!subTabs.length) return null;

  return (
    <div className={cx('tab-navigation')}>
      {subTabs.map(v => (
        <div
          className={cx(
            'tab',
            `col-${Math.floor(12 / subTabs.length)}`,
            subView === v.toUpperCase() && 'selected'
          )}
          key={`${v}-${new Date().getTime()}`}
          role="button"
          tabIndex={0}
          onClick={() => selectSubView(v)}
          onKeyDown={() => selectSubView(v)}
        >
          {v.includes('_') ? startCase(v.split('_')[1]) : startCase(v)}
        </div>
      ))}
    </div>
  );
};

export default SubTabBar;
